import { render, staticRenderFns } from "./ViewFamily.vue?vue&type=template&id=95758a4e&"
import script from "./ViewFamily.vue?vue&type=script&lang=js&"
export * from "./ViewFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports